import { Link } from 'react-router-dom';
import { nip19 } from 'nostr-tools';
import type { NostrEvent } from '@nostrify/nostrify';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { NoteContent } from '@/components/NoteContent';
import { useAuthor } from '@/hooks/useAuthor';
import { genUserName } from '@/lib/genUserName';

export function CommentItem({ comment }: { comment: NostrEvent }) {
  const author = useAuthor(comment.pubkey);
  const meta = author.data?.metadata;
  const name = meta?.display_name || meta?.name || genUserName(comment.pubkey);
  const npub = nip19.npubEncode(comment.pubkey);

  const date = new Date(comment.created_at * 1000).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return (
    <div className="flex gap-3">
      <Link to={`/${npub}`} className="shrink-0">
        <Avatar className="h-9 w-9">
          <AvatarImage src={meta?.picture} alt={name} />
          <AvatarFallback>{name.charAt(0).toUpperCase()}</AvatarFallback>
        </Avatar>
      </Link>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
          <Link
            to={`/${npub}`}
            className="font-medium text-foreground hover:text-primary transition-colors truncate"
          >
            {name}
          </Link>
          <time className="text-xs text-muted-foreground">{date}</time>
        </div>
        <div className="mt-1 text-foreground/90 break-words">
          <NoteContent event={comment} className="text-[0.95rem] leading-relaxed" />
        </div>
      </div>
    </div>
  );
}
